import { render, staticRenderFns } from "./ClientTabsContainer.vue?vue&type=template&id=2744e106&scoped=true"
import script from "./ClientTabsContainer.vue?vue&type=script&lang=js"
export * from "./ClientTabsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2744e106",
  null
  
)

export default component.exports